import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import SlideEditing from './slideEditing';

// strong inspiration from CkEditor 5's bold plugin
// https://github.com/ckeditor/ckeditor5-basic-styles/blob/master/src/bold.js
export default class AddSlide extends Plugin {
    static get requires() {
         return [SlideEditing];
    }

    static get pluginName() {
        return 'AddSlide';
    }
}